module.exports = __webpack_public_path__ + "static/media/UserMt.84def13f.svg";